import styled, { css } from 'styled-components';

export const Line = styled.div`
  ${({ theme }) => css`
    flex: 1;
    height: 0.1rem;
    background-color: ${theme.color.surface.light};
  `}
`;
